<template>
  <div class="chargecallback">
    充值结果： <span>{{status}}</span>&nbsp;&nbsp;充值流水号为：<span>{{reference}}</span>&nbsp;&nbsp;充值金额：<span>{{amount}}</span>
    <div class="btn-rechar">
      <router-link to="/Finance/Recharge">查看充值记录</router-link>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        reference: '',
        amount: '',
        status: ''
      }

    },
    methods: {
      init() {
        this.reference = this.$route.query.reference;
        this.amount = this.$route.query.amount;
        this.status = this.$route.query.status;
      },
    },
    created() {
      this.init();
    }
  }
</script>

<style>
  .chargecallback {
    padding-top: 120px;
    text-align: center;
  }

  .btn-rechar {
    background: #ffb700;
    padding: 10px 20px;
    width: 150px;
    margin: 50px auto 0;
    border-radius: 10px;
  }

  .btn-rechar a {
    color: #666;
  }
</style>



// WEBPACK FOOTER //
// src/pages/web/chargecallback.vue